import Vue from 'vue'
import Router from 'vue-router'

// 注意这两个
import noblock from './modules/noblock/index' //和登录，工作台平级 无归属
import noshowBlock from './modules/noshowBlock/index' //工作台内部， 无归属

import homePage from './modules/homePage/index'
import terrace from './modules/terrace/index'
import tax from './modules/tax/index'
import content from './modules/content/index'
import client from './modules/client/index'
import operate from './modules/operate/index'
import accretion from './modules/accretion/index'
import website from './modules/website/index'
import school from './modules/school/index'
import finance from './modules/finance/index'
import asset from './modules/asset/index'
import autoClassify from './modules/autoClassify/index'
import wechatOperate from './modules/wechatOperate/index'

/**
 * @date 2019/8/30/030
 * @Description: 解决vue中的NavigationDuplicated报错
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 特别的 会计中心
// const accountingCenter = () => import('@/components/A_spec_accountCenter/index')
// const accountingCenterBox = () => import('@/components/A_spec_accountCenter/box')

const navigation = () => import('@/components/index/navigation')
const noMoney = () => import('@/components/index/noMoney')
const NoFound = () => import('@/components/NoFound/NoFound');
const NoAuth = () => import('@/components/NoFound/NoAuth');


/**
 * @date 2020/4/8/008
 * @Description: meta 值说明
 * noStore: true,  注册页面这些不需要存值的
 * store:true 财税相关
 * taxNoShow:true  属于财税但是不显示在快捷导航栏
 * store:false 非财税相关
 * rule:Boolean ??
 */


/**
 * 页面写在modules文件夹下，按模块分页面，meta 满足store相关要求还有
 * 加上belong:{Array} 所属模块在modules/newMenu.js 下 查看总体归属
 */
Vue.use(Router)
let routerModules = new Router({
  mode: 'history',
  routes: [
    ...noblock,
    // 开启一个新标签页进入
    {
      path: '/',
      name: 'index',
      meta: {
        noStore: true,
      },
      redirect: '/login'
    },
    {
      path: '/',
      component: navigation,
      meta: {
        text: '工作台',
      },
      children: [
        ...noshowBlock,
        ...homePage,
        ...terrace,
        ...tax,
        ...content,
        ...client,
        ...operate,
        ...accretion,
        ...website,
        ...school,
        ...finance,
        ...asset,
        ...autoClassify,
        ...wechatOperate,
        {
          path: '/oweFee',
          name: 'noMoney',
          meta: {
            noStore: true
          },
          component: noMoney,
        },
        {
          path: '/NoAuth',
          meta: {
            noStore: true,
          },
          name: 'NoAuth',
          component: NoAuth
        },
        {
          path: '/404',
          meta: {
            noStore: true,
          },
          name: 'NoFound',
          component: NoFound
        },

      ]
    },
  ]
})

// 404页面动态加载 解决和动态路由的冲突
routerModules.addRoute({
  path: '*',
  meta: {
    noStore: true,
  },
  redirect: '/404',
})

export default routerModules
